<script>
    import userStore from '../stores/userStore';
    import { createEventDispatcher } from 'svelte';

    const dispatcher = createEventDispatcher();

    function editName()
    {
        dispatcher('editName');
    }

</script>

{#if $userStore}
<div class="vbox" style="text-align: center;" on:click={editName}>
    <span>{$userStore.name}</span>
    <div>
        <img class="profilePhoto" src={$userStore.avatar} alt="Photo">
    </div>
    <span>{$userStore.balance}</span>
</div>
{/if}

<style>
    .profilePhoto {
        width: 50px;
        height: 50px;
    }
    
    :global(.floatRight) {
        float: right;
    }
</style>